
    import '/Users/lijixiang/Work/power-design/site/docs/flow-components/comment.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-flow-components-comment-demo-comment","docs-flow-components-comment-demo-fixed-mode","docs-flow-components-comment-demo-empty"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/comment.md?type=demo')
};